import BimboPersonality from "@/employee/personalities/BimboPersonality"
import {
  EmptyPersonality, Personality
} from "@/employee/Personality"
import { ScholarPersonality } from "@/employee/personalities/ScholarPersonality"
import { SlutPersonality } from "@/employee/personalities/SlutPersonality"
import { BouncyPersonality } from "@/employee/personalities/BouncyPersonality"
import { CuddlyPersonality } from "@/employee/personalities/CuddlyPersonality"
import { ShyPersonality } from "@/employee/personalities/ShyPersonality"
import { GreedyPersonality } from "@/employee/personalities/GreedyPersonality"

export function allPersonalities(): {[name: string]: Personality} {
  return {
    bimbo: new BimboPersonality(),
    scholar: new ScholarPersonality(),
    slut: new SlutPersonality(),
    bouncy: new BouncyPersonality(),
    cuddly: new CuddlyPersonality(),
    shy: new ShyPersonality(),
    greedy: new GreedyPersonality()
  }
}

/** Maps old ids to existing personalities */
function oldPersonalities(): {[name: string]: Personality} {
  return {
    lover: new SlutPersonality()
  }
}

/**
 * Returns the personality corresponding to an id.
 * If the personality has been removed, another personality will be returned instead, or the empty personality.
 *
 * @param id
 */
export function getPersonality(id: string): Personality {
  if (id in allPersonalities()) {
    return allPersonalities()[id]
  } else if (id in oldPersonalities()) {
    return oldPersonalities()[id]
  }
  return new EmptyPersonality()
}

export function randomPersonality(affix: string = "either", currentPersonalities: string[] = []) {
  let listOfAll = Object.values(allPersonalities())

  for (let currentPersonalityName of currentPersonalities) {
    // Remove duplicates of current personalities
    let index = listOfAll.findIndex(p => p.id == currentPersonalityName)
    if (index != -1) {
      listOfAll.splice(index, 1)
    }

    // Remove conflicting personalities
    for (let conflictingPersonality of allPersonalities()[currentPersonalityName].conflictingPersonalities) {
      let index = listOfAll.findIndex(p => p.id == conflictingPersonality.id)
      if (index != -1) {
        listOfAll.splice(index, 1)
      }
    }
  }

  // Remove wrong affixes
  if (affix == "prefix" || affix == "suffix") {
    let i = listOfAll.length
    while (i--) {
      if (listOfAll[i].affix != affix) listOfAll.splice(i, 1)
    }
  }

  if (listOfAll.length > 0) {
    return listOfAll[Math.floor(Math.random() * listOfAll.length)]
  }

  return new EmptyPersonality()
}
